import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader, PageLoader, EmptyState } from '@/components/common/Layout';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { RiskBadge } from '@/components/common/RiskBadge';
import { api } from '@/lib/api';
import { fmtRel, fmtDate } from '@/lib/format';
import { useAuth, isFieldUser } from '@/lib/auth';

const STATUSES = ['All', 'Open', 'Assigned', 'Investigation pending', 'Field verification pending', 'Action in progress', 'Monitoring', 'Resolved', 'Closed'];

export default function IncidentsPage() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [status, setStatus] = useState('All');

  useEffect(() => {
    const params = { limit: 200 };
    if (status !== 'All') params.status = status;
    api.get('/incidents', { params }).then(r => setItems(r.data));
  }, [status]);

  return (
    <div className="p-6 max-w-[1400px] mx-auto">
      <PageHeader title={isFieldUser(user.role) ? 'My assigned incidents' : 'Incidents'}
                  subtitle="Operational cases converted from validated alerts." />
      <Card className="p-3 mb-4 flex gap-2 flex-wrap">
        {STATUSES.map(s => (
          <button key={s} onClick={() => setStatus(s)}
            data-testid={`incidents-filter-${s.replace(/ /g, '-')}`}
            className={`text-xs rounded-md px-2 py-1 border ${status === s ? 'bg-primary text-primary-foreground border-primary' : 'bg-secondary border-border hover:bg-secondary/70'}`}>{s}</button>
        ))}
      </Card>
      {!items ? <PageLoader /> : items.length === 0 ? <EmptyState title="No incidents" /> : (
        <Card className="p-0 divide-y divide-border">
          {items.map(i => (
            <Link key={i.id} to={`/app/incidents/${i.id}`}
                  className={`flex items-center gap-3 p-3 hover:bg-secondary/60 risk-stripe risk-stripe-${i.severity?.toLowerCase()}`}
                  data-testid={`incident-row-${i.id}`}>
              <span className="font-mono text-xs text-muted-foreground w-24 shrink-0">{i.number}</span>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{i.title}</div>
                <div className="text-xs text-muted-foreground">{i.status} · {fmtRel(i.created_at)}</div>
              </div>
              <Badge variant="outline" className="text-[10px]">{i.status}</Badge>
              <RiskBadge severity={i.severity} />
            </Link>
          ))}
        </Card>
      )}
    </div>
  );
}
